<section>
    <span class="breadcrumb" *ngFor="let breadcrumb of rendering.fields.breadcrumbs; let i = index">
        <span class="divider" *ngIf="i > 0">/</span>
        <xm-cms-text [field]="breadcrumb.fields.content"></xm-cms-text>
    </span>
</section>
